import { render } from "./Footer.vue?vue&type=template&id=4ee72d4d&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=4ee72d4d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee72d4d"]])

export default __exports__